import { render, staticRenderFns } from "./DialogRequestApproval.vue?vue&type=template&id=1b66678e&"
import script from "./DialogRequestApproval.vue?vue&type=script&lang=js&"
export * from "./DialogRequestApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports